import { render, staticRenderFns } from "./Deliverables.vue?vue&type=template&id=6dc6f2c0&scoped=true&"
import script from "./Deliverables.vue?vue&type=script&lang=js&"
export * from "./Deliverables.vue?vue&type=script&lang=js&"
import style0 from "./Deliverables.vue?vue&type=style&index=0&id=6dc6f2c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6f2c0",
  null
  
)

export default component.exports